/* eslint
max-classes-per-file: "warn",
*/

import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.User {
  export const GetAuthenticatedUser = async (): Promise<AuthResponse> => {
    const url = `/api/auth?handler=AuthenticatedUser&key=${Date.now().toString()}`;
    return easyfyAxios.get(
      url
    );
  };

  class AuthResponse {
    status: number;
    data: AuthResponseData;
  }
  class AuthResponseData {
    isLoggedIn: boolean;
    partialUI: string;
    favouritesCount: number;
    favouritesHeaderPartial: string;
    favouritesProductId: string[];
    eventLayer: any;
    isNewLogin: boolean;
  }
}

export default Easyfy.Web.Services.User;
